<div class="chips-header">
  <i class="pi pi-map-marker"></i>
  @if (addingLocation) {
    <span>Saving location...</span>
  } @else {
    @if (type() === types.origin) {
      <span>Place of receipt / Origin Location</span>
      <span class="chips-header__rule"></span>
    }
    @if (type() === types.destination) {
      <span>Destination Location / Place of delivery</span>
    }
  }
</div>

<div class="chips-box" [class.expanded]="isExpanded()">
  <div class="chips-wrapper">
    @if (locations?.length) {
      <p-autocomplete
        [multiple]="true"
        [typeahead]="false"
        [(ngModel)]="locations"
        (onUnselect)="removeElement($event)"
      >
        <ng-template let-item #selecteditem>
          <div
            [class.currently-edited]="currentEditedLocation.getId() === item.id"
            (mousedown)="isExpanded() ? editLocation(item) : false"
          >
            <strong>
              {{ item.getOfficialName() }}
            </strong>
            @if (!item.latitude) {
              <i
                class="pi pi-exclamation-triangle"
                pTooltip="This entry was not linked with Google Maps zip-code and/or coordinates. Inland haulage rate(s) may not be applied."
                tooltipPosition="right"
              >
              </i>
            }
          </div>
        </ng-template>
      </p-autocomplete>
    }
  </div>
  <div class="add-form">
    <div class="add-form__row">
      <div class="add-form__field inland-input">
        <span class="add-form__label">{{
          type() === types.origin ? "Origin Location" : "Destination Location"
        }}</span>
        <app-place-autocomplete
          dataCy="quote-inland"
          [value]="currentEditedLocation.inlandHaulage"
          [disabled]="addingLocation"
          [placeholder]="
            type() === types.origin ? 'Origin Location' : 'Destination Location'
          "
          (valueChange)="onInlandHaulageChange($event)"
          (placeSelect)="onPlaceSelect($event)"
          (pendingChange)="placePending = $event"
        ></app-place-autocomplete>
      </div>
      <div class="add-form__field">
        <span class="add-form__label form-control-label required">
          Country
        </span>
        <app-country-select
          [disabled]="addingLocation"
          [country]="currentEditedLocation.country"
          (countryChange)="currentEditedLocation.country = $event"
        >
        </app-country-select>
      </div>
      <div class="add-form__field">
        <span class="add-form__label form-control-label required">
          Postal Code
        </span>
        <input
          data-cy="quote-postal"
          pInputText
          type="text"
          required
          [disabled]="addingLocation"
          [(ngModel)]="currentEditedLocation.postalCode"
          [pattern]="postalCodePattern"
          (keyup)="clearDistance()"
          placeholder="Postal Code"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="off"
        />
      </div>
      <div
        class="add-form__actions"
        [class.edit-mode]="!!currentEditedLocation.getId()"
      >
        @if (!!currentEditedLocation.getId()) {
          <button
            pButton
            severity="primary"
            class="location-save"
            [disabled]="placePending"
            (click)="saveInland()"
          >
            <i class="pi pi-check"></i>
          </button>
        }
        @if (!currentEditedLocation.getId()) {
          <button
            pButton
            severity="primary"
            data-cy="location-add"
            class="location-add"
            [disabled]="!isValid() || placePending"
            (click)="addElement()"
          >
            <i class="pi pi-check"></i>
          </button>
        }
      </div>
    </div>
  </div>
</div>
